import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.Banner');

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1748919884996/KV.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1748919884549/kv-h5.jpg',
        title: t('title'),
        subTitle: t('subTitle'),
        desc: t('desc'),
        childrenA: (
            <div className="banner-imgs">
                <img src="https://websiteoss.ecoflow.com/upload/image/1745832397240/icon1.png" alt="" />
                <img src="https://websiteoss.ecoflow.com/upload/image/1745832397835/icon2.png" alt="" />
                <img src="https://websiteoss.ecoflow.com/upload/image/1745832397624/icon3.png" alt="" />
                <img src="https://websiteoss.ecoflow.com/upload/image/1745832398007/icon4.png" alt="" />
            </div>
        ),
        childrenB: <div className="banner-info">{t('info')}</div>,
    };

    const [bannerHeight, setBannerHeight] = useState(window.innerHeight);
    useEffect(() => {
        const callback = () => {
            if (typeof window !== 'undefined') {
                const { height = 0 } = document.querySelector('.ecoflow-frame-header')?.getBoundingClientRect() ?? {};
                const { height: navHeight = 0 } = document.querySelector('.product-menu')?.getBoundingClientRect() ?? {};
                // @ts-ignore
                setBannerHeight(window.innerHeight - height - navHeight);
            }
        };
        callback();
        window.addEventListener('resize', callback);
        return () => window.removeEventListener('resize', callback);
    }, []);
    return (
        <div className={styles.comp} id="Banner" style={{ '--banner-height': bannerHeight + 'px' }}>
            <EcoBanner {...dataA} />
        </div>
    );
}
